<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00061.installation.identification' | translate"
      [description]="
        'P00061.installation.identification.description' | translate
      "
    >
    </app-header-configuration>

    @if (currentForm) {
      <form [formGroup]="currentForm">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <app-information-title
                [title]="'P00061.installation.wfcode' | translate"
              ></app-information-title>

              <div class="position-relative">
                <ion-input
                  [placeholder]="
                    'P00061.installation.wfcode.placeholder' | translate
                  "
                  formControlName="wpWfCode"
                  mode="ios"
                ></ion-input>
              </div>

              <app-label-description
                [description]="
                  'P00061.installation.wfcode.description' | translate
                "
              ></app-label-description>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <app-information-title
                [title]="'P00061.installation.serialnumber' | translate"
              ></app-information-title>

              <div class="position-relative">
                <ion-input
                  [placeholder]="
                    'P00061.installation.serialnumber.placeholder' | translate
                  "
                  formControlName="wpSerialNumber"
                  mode="ios"
                ></ion-input>
              </div>

              <app-label-description
                [description]="
                  'P00061.installation.serialnumber.description' | translate
                "
              ></app-label-description>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
